<div class="card-password card col-md-12">
    <form (ngSubmit)="alterarSenha($event)">
      <div class="col-lg-5">
        <div class="row text-left">
          <div class="col-sm-12">
            <div class="form-group" appAnimate="fadeIn" delay="300">
              <label for="" class="control-label">Senha Atual</label>
              <input autocomplete="off" (keyup)="keyupPassword($event)" (focus)="focusInputPassword($event)" class="form-control" type="password" id="password" [(ngModel)]="senhaAtual" name="senhaAtual">
            </div>
          </div>
        </div>

        <div class="row text-left">
          <div class="col-sm-12">
            <div class="form-group" appAnimate="fadeIn" delay="300">
              <label for="" class="control-label">Nova Senha</label>
              <input autocomplete="off" (keyup)="keyupPassword($event)" (focus)="focusInputPassword($event)" class="form-control" type="password" id="newPassword" [(ngModel)]="novaSenha" name="novaSenha">
            </div>
          </div>
        </div>

        <div class="row text-left">
          <div class="col-sm-12">
            <div class="form-group" appAnimate="fadeIn" delay="300">
              <label for="" class="control-label">Confirmar Nova Senha</label>
              <input autocomplete="off" (keyup)="keyupPassword($event)" (focus)="focusInputPassword($event)" class="form-control" type="password" id="confirmNewPassword" [(ngModel)]="confirmarNovaSenha" name="confirmarNovaSenha">
            </div>
          </div>
        </div>

        <div class="col-sm-12">
          <div class="msg-error" *ngIf="msgPasswordError">
            <span>Não foi possível alterar a senha</span>
          </div>
          <div class="msg-error" *ngIf="msgInvalidPassword">
            <span>Senha incorreta</span>
          </div>
          <div class="msg-success" *ngIf="msgPasswordSuccess">
            <span>Senha alterada com sucesso!</span>
          </div>
        </div>
      </div>


      <div class="col-lg-5 password-streight">
        <div class="title">Crie uma senha forte:</div>
        <div>
          <span [hidden]="!hasOneLowercase" class="success"></span>
          <span [hidden]="hasOneLowercase" class="fail">x</span>
          <span>Uma letra minúscula</span>
        </div>
        <div>
          <span [hidden]="!hasOneUppercase" class="success"></span>
          <span [hidden]="hasOneUppercase" class="fail">x</span>
          <span>Uma letra maiúscula</span>
        </div>
        <div>
          <span [hidden]="!hasOneNumber" class="success"></span>
          <span [hidden]="hasOneNumber" class="fail">x</span>
          <span>Um número</span>
        </div>
        <div>
          <span [hidden]="!hasOneSpecialCharacter" class="success"></span>
          <span [hidden]="hasOneSpecialCharacter"class="fail">x</span>
          <span>Um caractere especial</span>
        </div>
        <div>
          <span [hidden]="!hasEightCharacters" class="success"></span>
          <span [hidden]="hasEightCharacters" class="fail">x</span>
          <span>8 letras no mínimo</span>
        </div>
        <div class="show-password">
          <input (change)="showCharacters($event)" id="show-password" type="checkbox" class="styled-checkbox">
          <label for="show-password"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><title>Visualizar caracteres</title><polyline points="4 8 7 11 12 6" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg></label>
          <span>Visualizar caracteres</span>
        </div>
      </div>

      <div class="col-md-2 p-0">
        <button type="submit" id="submit-senha" class="btn btn-grey pull-right">Salvar</button>
      </div>
    </form>
  </div>
